import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "form-item" }
const _hoisted_5 = { class: "form-item" }
const _hoisted_6 = { class: "form-item" }
const _hoisted_7 = {
  key: 0,
  class: "parameter-container"
}
const _hoisted_8 = {
  key: 1,
  class: "parameter-container"
}
const _hoisted_9 = {
  key: 2,
  class: "parameter-container"
}
const _hoisted_10 = { class: "range-group" }
const _hoisted_11 = { class: "range-column-name" }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "parameter-container" }
const _hoisted_14 = {
  class: "parameter-container",
  style: {"margin-top":"1vh"}
}
const _hoisted_15 = {
  key: 4,
  class: "domain-consistency-group"
}
const _hoisted_16 = { class: "parameter-container" }
const _hoisted_17 = {
  class: "parameter-container",
  style: {"margin-top":"1vh"}
}
const _hoisted_18 = { class: "remove-btn-wrapper domain-remove" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 5,
  class: "parameter-container"
}
const _hoisted_21 = {
  key: 6,
  class: "parameter-container"
}
const _hoisted_22 = { class: "range-group" }
const _hoisted_23 = { class: "range-column-name" }
const _hoisted_24 = {
  key: 7,
  class: "parameter-container"
}
const _hoisted_25 = { class: "range-group" }
const _hoisted_26 = {
  key: 0,
  class: "difference-columns-wrapper"
}
const _hoisted_27 = {
  key: 1,
  class: "range-column-name"
}
const _hoisted_28 = {
  key: 8,
  class: "parameter-container"
}
const _hoisted_29 = {
  key: 9,
  class: "parameter-container"
}
const _hoisted_30 = { class: "range-group" }
const _hoisted_31 = { class: "range-column-name" }
const _hoisted_32 = { class: "range-column-name" }
const _hoisted_33 = {
  key: 10,
  class: "parameter-container"
}
const _hoisted_34 = { class: "range-group" }
const _hoisted_35 = { class: "range-column-name" }
const _hoisted_36 = {
  key: 11,
  class: "parameter-container"
}
const _hoisted_37 = {
  key: 12,
  class: "logical-group-container"
}
const _hoisted_38 = {
  key: 0,
  class: "parameter-container"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 1,
  class: "logical-template-hint"
}
const _hoisted_41 = { class: "parameter-container" }
const _hoisted_42 = {
  class: "parameter-container",
  style: {"margin-top":"1vh"}
}
const _hoisted_43 = { class: "logical-relations-area" }
const _hoisted_44 = ["title"]
const _hoisted_45 = {
  key: 0,
  class: "range-group"
}
const _hoisted_46 = { class: "range-column-name" }
const _hoisted_47 = ["title"]
const _hoisted_48 = {
  key: 0,
  class: "range-group"
}
const _hoisted_49 = { class: "range-column-name" }
const _hoisted_50 = { class: "remove-btn-wrapper logical-remove" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 13,
  class: "sequence-group"
}
const _hoisted_53 = { class: "parameter-container" }
const _hoisted_54 = {
  class: "parameter-container",
  style: {"margin-top":"1vh"}
}
const _hoisted_55 = { class: "remove-btn-wrapper sequence-remove" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 14,
  class: "sequence-group"
}
const _hoisted_58 = ["title"]
const _hoisted_59 = { class: "remove-btn-wrapper sequence-remove" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 15,
  class: "placeholder-box"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 0,
  class: "form-item"
}
const _hoisted_65 = { class: "order-condition-container" }
const _hoisted_66 = { class: "order-row" }
const _hoisted_67 = { class: "order-row" }
const _hoisted_68 = { class: "order-row" }
const _hoisted_69 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, _cache[39] || (_cache[39] = [
        _createElementVNode("span", { class: "close-icon" }, "×", -1)
      ])),
      _cache[69] || (_cache[69] = _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("span", { class: "title-text" }, "Create Validation Rule")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[40] || (_cache[40] = _createElementVNode("div", { class: "form-label" }, [
            _createElementVNode("img", {
              src: "/cardpanel_icon/parameter-arrow.svg",
              class: "label-icon"
            }),
            _createTextVNode(" Column(s) ")
          ], -1)),
          _createVNode(_component_el_select, {
            modelValue: _ctx.selectedColumns,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedColumns) = $event)),
            multiple: "",
            placeholder: "Select Column(s)",
            class: "custom-select"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: col,
                  label: col,
                  value: col
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[41] || (_cache[41] = _createElementVNode("div", { class: "form-label" }, [
            _createElementVNode("img", {
              src: "/cardpanel_icon/parameter-arrow.svg",
              class: "label-icon"
            }),
            _createTextVNode(" Validation Rule Type ")
          ], -1)),
          _createVNode(_component_el_select, {
            modelValue: _ctx.ruleType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleType) = $event)),
            placeholder: "Select Rule Type",
            class: "custom-select",
            disabled: _ctx.selectedColumns.length === 0
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRuleTypes, (type) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: type.value,
                  label: type.label,
                  value: type.value,
                  disabled: type.disabled
                }, null, 8, ["label", "value", "disabled"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[64] || (_cache[64] = _createElementVNode("div", { class: "form-label" }, [
            _createElementVNode("img", {
              src: "/cardpanel_icon/parameter-arrow.svg",
              class: "label-icon"
            }),
            _createTextVNode(" Validation Rule Parameter ")
          ], -1)),
          (_ctx.ruleType === 'Type')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "parameter-label" }, "Type :", -1)),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.ruleParameters.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleParameters.type) = $event)),
                  placeholder: "Select Type",
                  class: "custom-select parameter-input"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "character",
                      value: "character"
                    }),
                    _createVNode(_component_el_option, {
                      label: "numeric",
                      value: "numeric"
                    }),
                    _createVNode(_component_el_option, {
                      label: "date",
                      value: "datetime"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_ctx.ruleType === 'Format')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", { class: "parameter-label" }, "Format :", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.format,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleParameters.format) = $event)),
                    multiple: "",
                    filterable: "",
                    "allow-create": "",
                    "default-first-option": "",
                    "reserve-keyword": false,
                    placeholder: "Please specify the regular expression",
                    class: "custom-select parameter-input"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.format, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : (_ctx.ruleType === 'Range')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[44] || (_cache[44] = _createElementVNode("span", { class: "parameter-label" }, "Range :", -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleParameters.range_min,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleParameters.range_min) = $event)),
                        placeholder: "min",
                        class: "range-input"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleParameters.range_min_op,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleParameters.range_min_op) = $event)),
                        class: "range-select"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "<",
                            value: "<"
                          }),
                          _createVNode(_component_el_option, {
                            label: "≤",
                            value: "<="
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.selectedColumns[0] || "Column"), 1),
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleParameters.range_max_op,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleParameters.range_max_op) = $event)),
                        class: "range-select"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "<",
                            value: "<"
                          }),
                          _createVNode(_component_el_option, {
                            label: "≤",
                            value: "<="
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleParameters.range_max,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ruleParameters.range_max) = $event)),
                        placeholder: "max",
                        class: "range-input"
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : (_ctx.ruleType === 'Integrity')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[45] || (_cache[45] = _createElementVNode("span", { class: "parameter-label parameter-label-aligned" }, "Detect Missing Value :", -1)),
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.ruleParameters.integrity_missingDetect,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleParameters.integrity_missingDetect) = $event)),
                          class: "custom-select parameter-input"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: true,
                              label: "true"
                            }),
                            _createVNode(_component_el_option, {
                              value: false,
                              label: "false"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[46] || (_cache[46] = _createElementVNode("span", { class: "parameter-label parameter-label-aligned" }, "Specific Missing Value (Optional) :", -1)),
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.ruleParameters.integrity_specialMissing,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleParameters.integrity_specialMissing) = $event)),
                          multiple: "",
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          "reserve-keyword": false,
                          placeholder: "Please input special missing values",
                          class: "custom-select parameter-input"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.integrity_specialMissing, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item,
                                label: item,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]))
                  : (_ctx.ruleType === 'Domain consistency (same entity)')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.domain_sameEntity, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "domain-pair-wrapper"
                          }, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "parameter-label domain-label" }, "Main Entity :", -1)),
                              _createVNode(_component_el_select, {
                                modelValue: item.mainEntity,
                                "onUpdate:modelValue": ($event: any) => ((item.mainEntity) = $event),
                                placeholder: "Select Main Entity",
                                class: "custom-select parameter-input",
                                onChange: ($event: any) => (_ctx.handleMainEntityChange(index))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableValues(index, 'main'), (val) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: val,
                                      label: val,
                                      value: val
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "parameter-label domain-label" }, "Same Entity :", -1)),
                              _createVNode(_component_el_select, {
                                modelValue: item.sameEntityList,
                                "onUpdate:modelValue": ($event: any) => ((item.sameEntityList) = $event),
                                multiple: "",
                                filterable: "",
                                placeholder: "Select Same Entities",
                                class: "custom-select parameter-input"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableValues(index, 'same'), (val) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: val,
                                      label: val,
                                      value: val
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              (_ctx.ruleParameters.domain_sameEntity.length > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "remove-btn",
                                    onClick: ($event: any) => (_ctx.removeSameEntityPair(index))
                                  }, " Remove ", 8, _hoisted_19))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128)),
                        _createElementVNode("button", {
                          class: "add-btn",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addSameEntityPair && _ctx.addSameEntityPair(...args)))
                        }, " + Add Entity Pair ")
                      ]))
                    : (_ctx.ruleType === 'Domain consistency (different domain)')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[49] || (_cache[49] = _createElementVNode("span", { class: "parameter-label" }, "Different Domain Entity :", -1)),
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.ruleParameters.domain_differentDomain,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleParameters.domain_differentDomain) = $event)),
                            multiple: "",
                            filterable: "",
                            "allow-create": "",
                            "default-first-option": "",
                            "reserve-keyword": false,
                            placeholder: "Select or input different domain entities",
                            class: "custom-select parameter-input"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnValues[_ctx.selectedColumns[0]] || [], (val) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: val,
                                  label: val,
                                  value: val
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : (_ctx.ruleType === 'Outlier')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _cache[50] || (_cache[50] = _createElementVNode("span", { class: "parameter-label" }, "Outlier Range :", -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleParameters.outlier_min,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleParameters.outlier_min) = $event)),
                                placeholder: "min",
                                class: "range-input"
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.ruleParameters.outlier_min_op,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleParameters.outlier_min_op) = $event)),
                                class: "range-select"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "<",
                                    value: "<"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "≤",
                                    value: "<="
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.selectedColumns[0] || "Column"), 1),
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.ruleParameters.outlier_max_op,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ruleParameters.outlier_max_op) = $event)),
                                class: "range-select"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "<",
                                    value: "<"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "≤",
                                    value: "<="
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.ruleParameters.outlier_max,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ruleParameters.outlier_max) = $event)),
                                placeholder: "max",
                                class: "range-input"
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : (_ctx.ruleType === 'Difference')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              _cache[51] || (_cache[51] = _createElementVNode("span", { class: "parameter-label" }, "Difference Range :", -1)),
                              _createElementVNode("div", _hoisted_25, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.ruleParameters.difference_min,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ruleParameters.difference_min) = $event)),
                                  placeholder: "min",
                                  class: "range-input"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.ruleParameters.difference_min_op,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.ruleParameters.difference_min_op) = $event)),
                                  class: "range-select"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "<",
                                      value: "<"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "≤",
                                      value: "<="
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (_ctx.selectedColumns.length > 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: col,
                                          class: "range-column-name difference-column-item"
                                        }, _toDisplayString(col), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.selectedColumns[0] || "Column"), 1)),
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.ruleParameters.difference_max_op,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.ruleParameters.difference_max_op) = $event)),
                                  class: "range-select"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "<",
                                      value: "<"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "≤",
                                      value: "<="
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.ruleParameters.difference_max,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.ruleParameters.difference_max) = $event)),
                                  placeholder: "max",
                                  class: "range-input"
                                }, null, 8, ["modelValue"])
                              ])
                            ]))
                          : (_ctx.ruleType === 'Duplicate')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                _cache[52] || (_cache[52] = _createElementVNode("span", { class: "parameter-label" }, "Detect Duplicate :", -1)),
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.ruleParameters.duplicate_detect,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.ruleParameters.duplicate_detect) = $event)),
                                  class: "custom-select parameter-input"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      value: true,
                                      label: "true"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: false,
                                      label: "false"
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : (_ctx.ruleType === 'Comparison relation (compare)')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _cache[53] || (_cache[53] = _createElementVNode("span", { class: "parameter-label" }, "Compare Relation :", -1)),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.selectedColumns[0] || "Column 1"), 1),
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.ruleParameters.compare_operator,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.ruleParameters.compare_operator) = $event)),
                                      class: "range-select"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_option, {
                                          label: "<",
                                          value: "<"
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "≤",
                                          value: "<="
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "=",
                                          value: "="
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: "≥",
                                          value: ">="
                                        }),
                                        _createVNode(_component_el_option, {
                                          label: ">",
                                          value: ">"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.selectedColumns[1] || "Column 2"), 1)
                                  ])
                                ]))
                              : (_ctx.ruleType === 'Comparison relation (substring)')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _cache[55] || (_cache[55] = _createElementVNode("span", { class: "parameter-label" }, "Substring Relation :", -1)),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.ruleParameters.substring_column,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.ruleParameters.substring_column) = $event)),
                                        placeholder: "Select Column",
                                        class: "custom-select",
                                        style: {"flex":"2"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: col,
                                              label: col,
                                              value: col
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]),
                                      _cache[54] || (_cache[54] = _createElementVNode("span", {
                                        class: "parameter-label",
                                        style: {"white-space":"nowrap","margin":"0 0.5vw"}
                                      }, "is substring of", -1)),
                                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.selectedColumns.find(
                  (c) => c !== _ctx.ruleParameters.substring_column
                ) || "Other Column"), 1)
                                    ])
                                  ]))
                                : (_ctx.ruleType === 'Computational relation')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _cache[56] || (_cache[56] = _createElementVNode("span", { class: "parameter-label" }, "Computational Relation :", -1)),
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.ruleParameters.computational_relation,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ruleParameters.computational_relation) = $event)),
                                        placeholder: "Please input computational relation",
                                        class: "custom-input parameter-input"
                                      }, null, 8, ["modelValue"])
                                    ]))
                                  : (_ctx.ruleType === 'Logical and condition')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        (_ctx.filteredLogicalRuleTemplates.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                              _cache[57] || (_cache[57] = _createElementVNode("span", {
                                                class: "parameter-label parameter-label-aligned",
                                                style: {"flex":"none"}
                                              }, " Load Existing Rule : ", -1)),
                                              _createVNode(_component_el_select, {
                                                modelValue: _ctx.selectedLogicalTemplateKey,
                                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.selectedLogicalTemplateKey) = $event)),
                                                placeholder: "Select rule to preload",
                                                class: "custom-select parameter-input",
                                                clearable: "",
                                                onChange: _ctx.handleLogicalTemplateChange
                                              }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLogicalRuleTemplates, (tpl) => {
                                                    return (_openBlock(), _createBlock(_component_el_option, {
                                                      key: tpl.key,
                                                      label: tpl.label,
                                                      value: tpl.key
                                                    }, null, 8, ["label", "value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }, 8, ["modelValue", "onChange"]),
                                              _createElementVNode("button", {
                                                class: "clear-template-btn",
                                                type: "button",
                                                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.clearLogicalTemplate && _ctx.clearLogicalTemplate(...args))),
                                                disabled: !_ctx.selectedLogicalTemplateKey
                                              }, " Clear ", 8, _hoisted_39)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.showLogicalTemplateReminder)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Current selection already matches an existing logical rule. Please add new columns or adjust the condition/constraint setup before submitting. "))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_41, [
                                          _cache[58] || (_cache[58] = _createElementVNode("span", { class: "parameter-label parameter-label-aligned" }, "Condition Column(s) :", -1)),
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.ruleParameters.logical_and_condition.conditionColumns,
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.ruleParameters.logical_and_condition.conditionColumns) = $event)),
                                            multiple: "",
                                            placeholder: "Select Condition Columns",
                                            class: "custom-select parameter-input"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: col,
                                                  label: col,
                                                  value: col,
                                                  disabled: 
                    _ctx.ruleParameters.logical_and_condition.constraintColumns.includes(
                      col
                    )
                  
                                                }, null, 8, ["label", "value", "disabled"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                          _cache[59] || (_cache[59] = _createElementVNode("span", { class: "parameter-label parameter-label-aligned" }, "Constraint Column(s) :", -1)),
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.ruleParameters.logical_and_condition.constraintColumns,
                                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.ruleParameters.logical_and_condition.constraintColumns) = $event)),
                                            multiple: "",
                                            placeholder: "Select Constraint Columns",
                                            class: "custom-select parameter-input"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: col,
                                                  label: col,
                                                  value: col,
                                                  disabled: 
                    _ctx.ruleParameters.logical_and_condition.conditionColumns.includes(
                      col
                    )
                  
                                                }, null, 8, ["label", "value", "disabled"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_43, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.logical_and_condition
                  .relations, (relation, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: index,
                                              class: "logical-pair-wrapper"
                                            }, [
                                              _cache[60] || (_cache[60] = _createElementVNode("div", {
                                                class: "parameter-container",
                                                style: {"margin-bottom":"0.5vh"}
                                              }, [
                                                _createElementVNode("span", {
                                                  class: "logical-section-label",
                                                  style: {"margin-bottom":"0","width":"8vw","display":"inline-block"}
                                                }, "Condition Column(s)")
                                              ], -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.logical_and_condition
                    .conditionColumns, (col) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: 'cond-' + col,
                                                  class: "parameter-container",
                                                  style: {"margin-bottom":"0.5vh"}
                                                }, [
                                                  (relation[col])
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("span", {
                                                          class: "parameter-label logical-col-label",
                                                          title: col
                                                        }, _toDisplayString(col) + " :", 9, _hoisted_44),
                                                        (_ctx.isNumericOrDate(col))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                              _createVNode(_component_el_input, {
                                                                modelValue: relation[col].min,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].min) = $event),
                                                                placeholder: "min",
                                                                class: "range-input"
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                              _createVNode(_component_el_select, {
                                                                modelValue: relation[col].min_op,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].min_op) = $event),
                                                                class: "range-select"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_el_option, {
                                                                    label: "<",
                                                                    value: "<"
                                                                  }),
                                                                  _createVNode(_component_el_option, {
                                                                    label: "≤",
                                                                    value: "<="
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                              _createElementVNode("span", _hoisted_46, _toDisplayString(col), 1),
                                                              _createVNode(_component_el_select, {
                                                                modelValue: relation[col].max_op,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].max_op) = $event),
                                                                class: "range-select"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_el_option, {
                                                                    label: "<",
                                                                    value: "<"
                                                                  }),
                                                                  _createVNode(_component_el_option, {
                                                                    label: "≤",
                                                                    value: "<="
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                              _createVNode(_component_el_input, {
                                                                modelValue: relation[col].max,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].max) = $event),
                                                                placeholder: "max",
                                                                class: "range-input"
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                            ]))
                                                          : (_openBlock(), _createBlock(_component_el_select, {
                                                              key: 1,
                                                              modelValue: relation[col].value,
                                                              "onUpdate:modelValue": ($event: any) => ((relation[col].value) = $event),
                                                              multiple: _ctx.isCharacterColumn(col),
                                                              "collapse-tags": 
                        _ctx.isCharacterColumn(col) &&
                        _ctx.shouldCollapseTags(relation[col].value)
                      ,
                                                              "max-collapse-tags": 
                        _ctx.getMaxVisibleTags(relation[col].value)
                      ,
                                                              "collapse-tags-tooltip": "",
                                                              class: "custom-select parameter-input logical-value-select",
                                                              placeholder: "Select Value"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableLogicalValues(index, col), (val) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: val,
                                                                    label: val,
                                                                    value: val
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["modelValue", "onUpdate:modelValue", "multiple", "collapse-tags", "max-collapse-tags"]))
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128)),
                                              _cache[61] || (_cache[61] = _createElementVNode("div", {
                                                class: "parameter-container",
                                                style: {"margin-top":"1vh","margin-bottom":"0.5vh","border-top":"1px solid #e0e0e0","padding-top":"1vh"}
                                              }, [
                                                _createElementVNode("span", {
                                                  class: "logical-section-label",
                                                  style: {"margin-bottom":"0","width":"8vw","display":"inline-block"}
                                                }, "Constraint Column(s)")
                                              ], -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.logical_and_condition
                    .constraintColumns, (col) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: 'cons-' + col,
                                                  class: "parameter-container",
                                                  style: {"margin-bottom":"0.5vh"}
                                                }, [
                                                  (relation[col])
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("span", {
                                                          class: "parameter-label logical-col-label",
                                                          title: col
                                                        }, _toDisplayString(col) + " :", 9, _hoisted_47),
                                                        (_ctx.isNumericOrDate(col))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                              _createVNode(_component_el_input, {
                                                                modelValue: relation[col].min,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].min) = $event),
                                                                placeholder: "min",
                                                                class: "range-input"
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                              _createVNode(_component_el_select, {
                                                                modelValue: relation[col].min_op,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].min_op) = $event),
                                                                class: "range-select"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_el_option, {
                                                                    label: "<",
                                                                    value: "<"
                                                                  }),
                                                                  _createVNode(_component_el_option, {
                                                                    label: "≤",
                                                                    value: "<="
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                              _createElementVNode("span", _hoisted_49, _toDisplayString(col), 1),
                                                              _createVNode(_component_el_select, {
                                                                modelValue: relation[col].max_op,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].max_op) = $event),
                                                                class: "range-select"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_el_option, {
                                                                    label: "<",
                                                                    value: "<"
                                                                  }),
                                                                  _createVNode(_component_el_option, {
                                                                    label: "≤",
                                                                    value: "<="
                                                                  })
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                                              _createVNode(_component_el_input, {
                                                                modelValue: relation[col].max,
                                                                "onUpdate:modelValue": ($event: any) => ((relation[col].max) = $event),
                                                                placeholder: "max",
                                                                class: "range-input"
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                            ]))
                                                          : (_openBlock(), _createBlock(_component_el_select, {
                                                              key: 1,
                                                              modelValue: relation[col].value,
                                                              "onUpdate:modelValue": ($event: any) => ((relation[col].value) = $event),
                                                              multiple: _ctx.isCharacterColumn(col),
                                                              "collapse-tags": 
                        _ctx.isCharacterColumn(col) &&
                        _ctx.shouldCollapseTags(relation[col].value)
                      ,
                                                              "max-collapse-tags": 
                        _ctx.getMaxVisibleTags(relation[col].value)
                      ,
                                                              "collapse-tags-tooltip": "",
                                                              class: "custom-select parameter-input logical-value-select",
                                                              placeholder: "Select Value"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnValues[col] || [], (val) => {
                                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                                    key: val,
                                                                    label: val,
                                                                    value: val
                                                                  }, null, 8, ["label", "value"]))
                                                                }), 128))
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["modelValue", "onUpdate:modelValue", "multiple", "collapse-tags", "max-collapse-tags"]))
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128)),
                                              _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("button", {
                                                  class: "remove-btn",
                                                  onClick: ($event: any) => (_ctx.removeLogicalRelation(index))
                                                }, " Remove ", 8, _hoisted_51)
                                              ])
                                            ]))
                                          }), 128)),
                                          _createElementVNode("button", {
                                            class: "add-btn",
                                            onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.addLogicalRelation && _ctx.addLogicalRelation(...args)))
                                          }, " + Add Relation ")
                                        ])
                                      ]))
                                    : (_ctx.ruleType === 'Sequence')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.sequence, (item, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: index,
                                              class: "sequence-pair-wrapper"
                                            }, [
                                              _createElementVNode("div", _hoisted_53, [
                                                _cache[62] || (_cache[62] = _createElementVNode("span", { class: "parameter-label sequence-label" }, "Current Value :", -1)),
                                                _createVNode(_component_el_select, {
                                                  modelValue: item.currentValue,
                                                  "onUpdate:modelValue": ($event: any) => ((item.currentValue) = $event),
                                                  placeholder: "Select Current Value",
                                                  class: "custom-select parameter-input"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableSequenceValues(index, 'current'), (val) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        key: val,
                                                        label: val,
                                                        value: val
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_54, [
                                                _cache[63] || (_cache[63] = _createElementVNode("span", { class: "parameter-label sequence-label" }, " Allowed Next Value : ", -1)),
                                                _createVNode(_component_el_select, {
                                                  modelValue: item.nextValues,
                                                  "onUpdate:modelValue": ($event: any) => ((item.nextValues) = $event),
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder: "Select Allowed Next Values",
                                                  class: "custom-select parameter-input"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableSequenceValues(index, 'next'), (val) => {
                                                      return (_openBlock(), _createBlock(_component_el_option, {
                                                        key: val,
                                                        label: val,
                                                        value: val
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_55, [
                                                (_ctx.ruleParameters.sequence.length > 0)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "remove-btn",
                                                      onClick: ($event: any) => (_ctx.removeSequencePair(index))
                                                    }, " Remove ", 8, _hoisted_56))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          }), 128)),
                                          _createElementVNode("button", {
                                            class: "add-btn",
                                            onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.addSequencePair && _ctx.addSequencePair(...args)))
                                          }, " + Add Sequence Pair ")
                                        ]))
                                      : (_ctx.ruleType === 'Mapping and cardinality')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleParameters.mapping_cardinality, (pair, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: "sequence-pair-wrapper"
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedColumns, (col) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: col,
                                                    class: "parameter-container",
                                                    style: {"margin-bottom":"1vh"}
                                                  }, [
                                                    _createElementVNode("span", {
                                                      class: "parameter-label sequence-label",
                                                      title: col
                                                    }, _toDisplayString(col) + " :", 9, _hoisted_58),
                                                    _createVNode(_component_el_select, {
                                                      modelValue: pair[col],
                                                      "onUpdate:modelValue": ($event: any) => ((pair[col]) = $event),
                                                      multiple: "",
                                                      placeholder: "Select Value",
                                                      class: "custom-select parameter-input"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableMappingValues(index, col), (val) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: val,
                                                            label: val,
                                                            value: val
                                                          }, null, 8, ["label", "value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                }), 128)),
                                                _createElementVNode("div", _hoisted_59, [
                                                  _createElementVNode("button", {
                                                    class: "remove-btn",
                                                    onClick: ($event: any) => (_ctx.removeMappingPair(index))
                                                  }, " Remove ", 8, _hoisted_60)
                                                ])
                                              ]))
                                            }), 128)),
                                            _createElementVNode("button", {
                                              class: "add-btn",
                                              onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.addMappingPair && _ctx.addMappingPair(...args)))
                                            }, " + Add Mapping Pair ")
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                            (_ctx.ruleType)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_62, "Parameters for " + _toDisplayString(_ctx.ruleType) + " (To be implemented)", 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_63, "Please select a rule type first"))
                                          ]))
        ]),
        (['Sequence', 'Difference'].includes(_ctx.ruleType))
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _cache[68] || (_cache[68] = _createElementVNode("div", { class: "form-label" }, [
                _createElementVNode("img", {
                  src: "/cardpanel_icon/parameter-arrow.svg",
                  class: "label-icon"
                }),
                _createTextVNode(" Order Condition ")
              ], -1)),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _cache[65] || (_cache[65] = _createElementVNode("span", { class: "order-label" }, "First Order:", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.orderCondition.firstOrderColumn,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.ruleParameters.orderCondition.firstOrderColumn) = $event)),
                    placeholder: "Column",
                    class: "custom-select order-col-select",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: col,
                          label: col,
                          value: col
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.orderCondition.firstOrderType,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.ruleParameters.orderCondition.firstOrderType) = $event)),
                    class: "custom-select order-type-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Asc",
                        value: "Asc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Desc",
                        value: "Desc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Disorder",
                        value: "Disorder"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _cache[66] || (_cache[66] = _createElementVNode("span", { class: "order-label" }, "Second Order:", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.orderCondition.secondOrderColumn,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.ruleParameters.orderCondition.secondOrderColumn) = $event)),
                    placeholder: "Column",
                    class: "custom-select order-col-select",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: col,
                          label: col,
                          value: col
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.orderCondition.secondOrderType,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.ruleParameters.orderCondition.secondOrderType) = $event)),
                    class: "custom-select order-type-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Asc",
                        value: "Asc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Desc",
                        value: "Desc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Disorder",
                        value: "Disorder"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _cache[67] || (_cache[67] = _createElementVNode("span", { class: "order-label" }, "Third Order:", -1)),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.orderCondition.thirdOrderColumn,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.ruleParameters.orderCondition.thirdOrderColumn) = $event)),
                    placeholder: "Column",
                    class: "custom-select order-col-select",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: col,
                          label: col,
                          value: col
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.ruleParameters.orderCondition.thirdOrderType,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.ruleParameters.orderCondition.thirdOrderType) = $event)),
                    class: "custom-select order-type-select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Asc",
                        value: "Asc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Desc",
                        value: "Desc"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Disorder",
                        value: "Disorder"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_69, [
        _createElementVNode("button", {
          class: "submit-btn",
          onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.submitModal && _ctx.submitModal(...args)))
        }, "Submit")
      ])
    ])
  ]))
}